import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=c32145b4&scoped=true"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=c32145b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32145b4",
  null
  
)

export default component.exports